/**
 * weddingInvitations — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const weddingInvitationsPack: ToilePack = {
    slug: 'wedding-invitations',
    category: 'wedding',
    name: 'Wedding invitations',
    tagline: tagline('invitations', 'suites', 'print styles'),
    chips: chips('suites', 'styles'),
    ratio: A4,
    readings: [
        {key: 'botanical', label: 'Botanical garden', subject: 'eucalyptus, olive branches and ranunculus framing the card'},
        {key: 'celestial', label: 'Celestial night', subject: 'a crescent moon, stars and constellation lines on a night sky'},
        {key: 'deco', label: 'Art-deco gold', subject: 'fan motifs, stepped geometric borders and thin gold rules'},
    ],
    styles: [
        {key: 'watercolor', label: 'Watercolor', style: 'loose watercolor washes, soft bleeding edges', palette: 'painterly, romantic, on cotton paper', framing: 'names and date centered, wide margins'},
        {key: 'letterpress', label: 'Letterpress', style: 'a single ink impressed into thick cotton stock', palette: 'one ink on cream, one thin rule', framing: 'names and date centered, wide white space'},
        {key: 'gouache', label: 'Gouache', style: 'opaque hand-painted motifs, visible brush texture', palette: 'rich saturated, illustration crowding the borders', framing: 'names and date centered, wide margins'},
    ],
    directions: ['a coastal theme instead', 'in burgundy and blush', 'plainer, less ornament'],
}
